module.exports = __webpack_public_path__ + "c680f00fd3423aed602beb1e1aca1752.svg";